<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container
    [observables]="[InvoiceRegisterModel$]"
></ef-loading-container>
<div class="card">
    <ef-invoice-register-filters-presenter
        [StartDate]="(userInfo$ | async)?.LastInvoiceStart"
        [EndDate]="(userInfo$ | async)?.LastInvoiceEnd"
        [Contracts]="contractsSelectItems$ | async"
        (SelectStartDate)="SelectStartDate.next($event)"
        (SelectEndDate)="SelectEndDate.next($event)"
        (SelectContracts)="SelectedContractsSubject.next($event)"
        (FilterInvoiceNumber)="FilterInvoiceNumberSubject.next($event)"
    ></ef-invoice-register-filters-presenter>
    <ef-invoice-register-presenter
        [items]="InvoiceRegisterModel$ | async"
        [SelectedContracts]="SelectedContractsSubject.asObservable() | async"
        [InvoiceNumber]="FilterInvoiceNumberSubject.asObservable() | async"
    ></ef-invoice-register-presenter>
</div>

